import { stringify } from 'query-string';

import { FetchCrudData, StoreField } from '../models';
import { Network } from '../utils';

const fields = [
  StoreField.EXTERNAL_ID,
  StoreField.NAME,
  // StoreField.DEFAULT_LANGUAGE,
].join(',');

export const getStoresAndDepartments = async (filters: FetchCrudData) => {
  const queryParams = {
    ...filters,
    fields,
    s: JSON.stringify(filters.s),
    join: ['departments', 'departments.departmentTemplate'],
  };
  return Network.get(`stores?${stringify(queryParams)}`);
};
export const addStore = async store => Network.post('stores', store);
export const editStore = async (id, store) => Network.patch(`stores/${id}`, store);
export const deleteStore = async id => Network.delete(`stores/${id}`);

export const getStore = async id => {
  return Network.get(
    `stores/${id}?${stringify({
      join: ['departments', 'departments.departmentTemplate'],
    })}`,
  );
};
